import { BaseActionReducer } from '../../../../common/baseActionReducer';
import { LeagueMatchClient, baseUrl } from "../../../../api";
export const leagueMatchAdminActionReducer = new BaseActionReducer({ keyStart: 'LEAGUE_MATCH', payloadName: 'match' });
const syncActionCreators = leagueMatchAdminActionReducer.buildSyncActions();
const leagueMatchClient = new LeagueMatchClient(null, baseUrl);
const asyncActionCreators = {
    getLeagueMatch: (leagueMatchId) => {
        return leagueMatchAdminActionReducer.createAsyncAction(leagueMatchClient.getLeagueMatch(leagueMatchId));
    },
    updateLeagueMatch: (leagueMatchId, leagueMatch) => {
        return leagueMatchAdminActionReducer.createAsyncAction(leagueMatchClient.updateLeagueMatch(leagueMatchId, leagueMatch));
    }
};
export const leagueTeamActions = Object.assign(Object.assign({}, syncActionCreators), asyncActionCreators);
